<template>
  <div class="ticket-right-sidebar">
    <div v-if="ticketStore.isTicketSelected === false" class="p-2">
      <p>{{ $t("ticket.please_select_ticket") }}</p>
    </div>
    <div v-else class="ticket-right-sidebar-content">
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
        "
      >
        <p class="tab-title">
          {{ $t("general.profile") }}
        </p>
        <FeatherIcon
          v-if="ticketStore.toggleRightSidebar"
          class="menu-icon"
          style="margin-top: 0.15em"
          icon="XIcon"
          size="20"
          @click="ticketStore.setToggleRightSidebar()"
        />
      </div>
      <!--      <b-spinner-->
      <!--        v-if="loading"-->
      <!--        small-->
      <!--        label="Spinning"-->
      <!--      />-->

      <div class="mb-2">
        <TicketChatMeDetailInfo v-if="ticketStore.isChatMeTicket" :room-id="ticketStore.getSelectedTicketDetailRoomId"/>
        <TicketDetailInfo v-else />
      </div>
      <div class="mb-2">
        <TicketDetailAssign :data="ticketStore.getSelectedTicketDetailAssign" />
      </div>

      <!-- <TicketHistory
        v-if="ticketStore.isChatMeTicket"
        :room-id="ticketStore.getSelectedTicketDetailRoomId"
        :history="ticketStore.getChatMeTicketHistory"
        :is-private-chat="ticketStore.isChatMeTicket"
        :loading="ticketStore.loading.isSubmitting"
        :options="ticketStore.getOptions"
        @submit-respond="handleSubmitRespond"
      /> -->

      <!-- <TicketHistory
        v-else
        :customer-id="ticketStore.getSelectedTicketDetailCustomerID"
        :email="ticketStore.selectedTicketCustomer.email"
        :history="ticketStore.getTicketListHistory"
        :loading="ticketStore.loading.isSubmitting"
        :options="ticketStore.getOptions"
        @submit-respond="handleSubmitRespond"
      /> -->
      <!--      @submit="(createForm) => handleSubmit(ticketStore,createForm)"-->
    </div>
  </div>
</template>

<script>
import TicketDetailInfo from "@/views/ticket/ticketRightSidebar/ticketDetailInfo.vue";
import TicketChatMeDetailInfo from "@/views/ticket/ticketRightSidebar/ticketChatMeDetailInfo.vue";
import TicketHistory from "@/views/ticket/ticketRightSidebar/ticketHistory.vue";
import { BSpinner, BToast } from "bootstrap-vue";
import useTicketStore from "@/store-pinia/useTicketStore";
import TicketDetailAssign from "@/views/ticket/ticketRightSidebar/ticketDetailAssign.vue";
import Toast from "@/libs/toast";
import useWidth from "@/composibles/useWidth";

export default {
  components: {
    TicketChatMeDetailInfo,
    TicketDetailAssign,
    TicketHistory,
    TicketDetailInfo,
    BToast,
    BSpinner,
  },
  methods: {
    makeSuccessToast(append = false) {
      Toast.fire({
        icon: "success",
        title: this.$t("ticket.create_ticket_successfully_message"),
      });
    },
    makeFailToast(append = false) {
      Toast.fire({
        icon: "error",
        title: this.$t("ticket.create_ticket_failed_message"),
      });
    },
    async handleSubmitRespond(response) {
      // const result = await ticketStore.createTicketAsync(createForm, ticketStore.getSelectedTicketDetailCustomerID)
      if (response) {
        this.makeSuccessToast(true);
      } else {
        this.makeFailToast(true);
      }
    },
  },
  setup() {
    const ticketStore = useTicketStore();
    // async function handleSubmit(createForm) {
    //   await ticketStore.createTicketAsync(createForm, ticketStore.getSelectedTicketDetailCustomerID)
    // }
    return {
      ticketStore,
      // handleSubmit,
    };
  },
};
</script>

<style lang="scss" scoped>
.tab-title {
  margin-bottom: 1em;
  color: #8d5185;
  font-size: 1.15em;
  font-weight: bold;
}

.ticket-right-sidebar {
  border-top-left-radius: 0;
  border-bottom-right-radius: 0;
}

.ticket-right-sidebar-content {
  padding: 1.5em 1.5em;
}

.menu-icon {
  @media (min-width: 1000px) {
    display: none;
  }

  cursor: pointer;
}
</style>
